// Events Browser Page /events

import { Controller } from "stimulus"
import $ from 'jquery'

enum EventOrdering {
  ASCENDING = '1',
  DESCENDING = '-1'
}

function flatten(arr) {
  return arr.reduce(function (flat, toFlatten) {
    return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten)
  }, [])
}

function removeDuplicated(arr) {
  let s = new Set(arr)
  let it = s.values()
  return Array.from(it).filter(i => !!i)
}

export default class extends Controller {
  static targets = ["tabBar", "event", "content", "empty", "regions", "interests" ]

  readonly tabBarTarget!: Element
  readonly eventTargets!: Element[]
  readonly contentTarget!: Element
  readonly emptyTarget!: Element
  readonly regionsTarget!: Element
  readonly interestsTarget!: Element

  spacerHtml: string

  years: number[] = []

  filterYear: number | null = null
  filterRegionId: number | null = null
  filterInterestId: number | null = null
  order: EventOrdering = EventOrdering.ASCENDING

  connect() {
    this.spacerHtml = $('.event-spacer-row')[0].outerHTML

    this.emptyTarget.textContent = "We do not currently have any events upcoming for your search criteria"

    this.eventTargets.forEach((el, i) => {
      this.years.push(parseInt(el.getAttribute('data-year')))
    })

    // Remove duplicates
    this.years = this.years.filter((item, pos) => this.years.indexOf(item) == pos)
    
    this.years.forEach(y => {
      $(this.tabBarTarget).append(`<li class="tabs-title" data-action="click->events#switchYear"><a href="javascript:void(0)" data-year="${y}">${y}</a></li>`)
    })
  }

  switchYear(event) {
    $(this.tabBarTarget).find('li').removeClass('is-active')
    $(event.target).parent().addClass('is-active')

    if ($(event.target).data('year')) {
      this.filterYear = parseInt($(event.target).data('year'))
    } else {
      this.filterYear = null
    }

    this.updateFilters()
  }

  switchRegion(event) {
    if (event.target.value.length > 0) {
      this.filterRegionId = parseInt(event.target.value)
    } else {
      this.filterRegionId = null
    }

    this.updateFilters()
    this.filterYears()
  }

  switchInterest(event) {
    if (event.target.value.length > 0) {
      this.filterInterestId = parseInt(event.target.value)
    } else {
      this.filterInterestId = null
    }

    this.updateFilters()
    this.filterYears()
  }

  updateFilters() {
    let visibleCount = 0

    this.eventTargets.forEach((el, i) => {
      let matches = true
      let $el = $(el)

      if (this.filterYear != null && $el.data('year') != this.filterYear) {
        matches = false
      }
      
      if (this.filterRegionId != null && !this.targetRegions($el).includes(this.filterRegionId)) {
        matches = false
      }
      
      if (this.filterInterestId != null && !this.targetInterests($el).includes(this.filterInterestId)) {
        matches = false
      }

      if (matches) {
        $el.show()
        visibleCount++
      } else {
        $el.hide()
      }
    })

    this.reorder()
    this.intersperseDividers()

    this.filterRegions()
    this.filterInterests()

    // Show message if no events are available for this search
    if (visibleCount < 1) {
      $(this.emptyTarget).show()
    } else {
      $(this.emptyTarget).hide()
    }
  }

  reorder(event?) {
    if (event) {
      this.order = event.target.value as EventOrdering
    }

    let ordered = this.eventTargets.sort((a, b) => {
      let aI = parseInt(a.getAttribute('data-order'))
      let bI = parseInt(b.getAttribute('data-order'))

      if (this.order == EventOrdering.ASCENDING) {
        return aI - bI
      } else {
        return bI - aI
      }
    })
    
    ordered.forEach((e) => {
      let parent = e.parentNode
      let detached = parent.removeChild(e)
      parent.appendChild(detached)
    })

    this.intersperseDividers()
  }

  intersperseDividers() {
    const spacerTemplate = this.spacerHtml
    $('.event-spacer-row').remove()

    $('.event-row').each(function() {
      if ($(this).is(':visible')) {
        $(spacerTemplate).insertAfter($(this))
      }
    })
    $('.event-spacer-row').last().remove()
  }

  visibleRegions() {
    return removeDuplicated(flatten(this.eventTargets.map((el, i) => {
      if ($(el).is(':visible')) {
        return this.targetRegions($(el))
      }
    })))
  }

  visibleInterests() {
    return removeDuplicated(flatten(this.eventTargets.map((el, i) => {
      if ($(el).is(':visible')) {
        return this.targetInterests($(el))
      }
    })))
  }

  visibleYears() {
    return removeDuplicated(this.eventTargets.map((el, i) => {
      const $el = $(el)
      // Don't work on :visible property because this will be scoped to a currently selected year
      let filtered = true

      if (this.filterRegionId != null && !this.targetRegions($el).includes(this.filterRegionId)) {
        filtered = false
      }
      
      if (this.filterInterestId != null && !this.targetInterests($el).includes(this.filterInterestId)) {
        filtered = false
      }

      if (filtered) {
        return $el.data('year')
      }
    }))
  }

  // Only show tabs that are available
  filterYears() {
    const distinct = this.visibleYears()

    $(this.tabBarTarget).find('a').each(function() {
      if ($(this).data('year')) {
        if (distinct.includes($(this).data('year'))) {
          $(this).show()
        } else {
          $(this).hide()
        }
      }
    })
  }

  filterRegions() {
    const distinct = this.visibleRegions()
    const self = this

    $(this.regionsTarget).find('option').each(function() {
      if (!self.filterInterestId) {
        $(this).prop('disabled', false)
        return
      }

      if ($(this).val()) {
        if (distinct.includes(parseInt($(this).attr('value')))) {
          $(this).prop('disabled', false)
        } else {
          $(this).prop('disabled', true)
        }
      }
    })
  }

  filterInterests() {
    const distinct = this.visibleInterests()
    const self = this

    $(this.interestsTarget).find('option').each(function() {
      if (!self.filterRegionId) {
        $(this).prop('disabled', false)
        return
      }

      if ($(this).val()) {
        if (distinct.includes(parseInt($(this).attr('value')))) {
          $(this).prop('disabled', false)
        } else {
          $(this).prop('disabled', true)
        }
      }
    })
  }

  targetInterests($el) {
    if ($el.data('interest')) {
      // Use attr to receive data attribute as a string instead of auto converted to int
      return $el.attr('data-interest').split(',').map(v => parseInt(v))
    } else {
      return []
    }
  }

  targetRegions($el) {
    if ($el.data('region')) {
      // Use attr to receive data attribute as a string instead of auto converted to int
      return $el.attr('data-region').split(',').map(v => parseInt(v))
    } else {
      return []
    }
  }
}
